import { render, staticRenderFns } from "./OrderEditDialog.vue?vue&type=template&id=f8206c50&scoped=true"
import script from "./OrderEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderEditDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderEditDialog.vue?vue&type=style&index=0&id=f8206c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8206c50",
  null
  
)

export default component.exports